<template>
  <div>
    <el-checkbox-group
      v-model="modelValue"
      @change="changeSetting"
    >
      <el-checkbox
        :label="item.id"
        v-for="item in currentSettingList"
        :key="item.id"
        >{{ item.name }}</el-checkbox
      >
    </el-checkbox-group>
  </div>
</template>
<script>
// 视频素材优化选项
const videoSettingList = [
  {
    id: 'GENERATE_LANDING_PAGE_PREVIEW',
    name: '在广告中展示着陆页的屏幕截图',
  },
  {
    id: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
    name: '获取竖屏视频和方形视频',
  },
  {
    id: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
    name: '为视频生成时长较短的版本',
  },
];

// 图片素材优化选项
const imageSettingList = [
  {
    id: 'GENERATE_DESIGN_VERSIONS_FOR_IMAGES',
    name: '自适应布局',
  },
  {
    id: 'GENERATE_VIDEOS_FROM_OTHER_ASSETS',
    name: '自动生成视频',
  },
];

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    // 素材类型: video | image
    type: {
      type: String,
      default: 'video',
    },
  },
  data() {
    return {
      modelValue: [],
    };
  },
  computed: {
    currentSettingList() {
      return this.type === 'video' ? videoSettingList : imageSettingList;
    },
    defaultValue() {
      if (this.type === 'video') {
        return [
          { type: 'GENERATE_LANDING_PAGE_PREVIEW', enabled: false },
          { type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS', enabled: true },
          { type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS', enabled: true },
        ];
      }
      return [
        { type: 'GENERATE_DESIGN_VERSIONS_FOR_IMAGES', enabled: false },
        { type: 'GENERATE_VIDEOS_FROM_OTHER_ASSETS', enabled: false },
      ];
    },
    emitData() {
      return this.currentSettingList.map((v) => {
        return {
          type: v.id,
          enabled: this.modelValue.includes(v.id),
        };
      });
    },
  },
  methods: {
    changeSetting() {
      this.$emit('input', this.emitData);
    },
  },
  watch: {
    value: {
      handler() {
        const valueToUse = this.value && this.value.length > 0 ? this.value : this.defaultValue;
        this.modelValue = valueToUse.filter((v) => v.enabled).map((v) => v.type);
      },
      deep: true,
      immediate: true,
    },
    type: {
      handler() {
        // 类型切换时重置为默认值
        this.modelValue = this.defaultValue.filter((v) => v.enabled).map((v) => v.type);
        this.$emit('input', this.emitData);
      },
    },
  },
};
</script>
<style lang="scss" scoped></style>
